// extracted by mini-css-extract-plugin
module.exports = {"block":"GuideModal_block__CnXe_","title":"GuideModal_title__3nM64","content":"GuideModal_content__OzRfQ"};